import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { FormLabel, FormGroup } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CheckBox from "../Forms/CheckboxWithLabel";

import { styles } from "./styles";

const MyChecksFilter = (props) => {
  const { classes, onSearchCriteriaChange } = props;
  const { t } = useTranslation();
  const [requestedByMe, setRequestedByMe] = useState(true);
  const [assignedToMe, setAssignedToMe] = useState(false);

  const requestedByMeChange = async (e) => {
    setRequestedByMe(e.target.checked);
    
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ requestedByMe: e.target.checked, assignedToMe});
    }
  };

  const assignedToMeChange = async (e) => {
    setAssignedToMe(e.target.checked);
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ assignedToMe: e.target.checked, requestedByMe});
    }
  };

  return (
    <div className={classes.filterContainer}>
      <FormLabel className={classes.headerLabel}>{t("labels.filter.myChecks")}</FormLabel>
      <FormGroup>
        <div className={classes.checkBoxContainer}>
          <CheckBox
            label={t("labels.filter.requestedByMe")}
            onChange={requestedByMeChange}
            value={requestedByMe}
          />
        </div>
        <div className={classes.checkBoxContainer}>
          <CheckBox
            label={t("labels.filter.assignedToMe")}
            onChange={assignedToMeChange}
            value={assignedToMe}
          />
        </div>
      </FormGroup>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(MyChecksFilter);
